import { render, staticRenderFns } from "./Investigation.vue?vue&type=template&id=c943077c&scoped=true&"
import script from "./Investigation.vue?vue&type=script&lang=ts&"
export * from "./Investigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c943077c",
  null
  
)

export default component.exports